import PlaneAction from "./PlaneAction.js";
import { moveTo, setAirborn, setPower, setTas, setCondition, CONDITION_TYPES } from "../planeSlice.js";
import { getLDR, convertToMeters } from "../../assets/virtual-flyout/perf-calc.js";
import { getHeadTailWind, getRunwayHeading } from "../../assets/virtual-flyout/nav-calc.js";
import { getAirportDetails, getRunwayDistances, getActiveRunway } from "../../assets/virtual-flyout/airport-service.js";

export default class Land extends PlaneAction {
    constructor(planeId, airport) {
        super(planeId);
        this.airport = airport;
        this.landed = false;
    }

    execute() {
        this.log(`Landing at ${this.airport.code}`);

        const plane = this.getState();
        const runway = getActiveRunway(this.airport.code, plane.wind.heading).runway;
        const runwayHeading = getRunwayHeading(runway);
        const {LDA} = getRunwayDistances(this.airport.code, runway);
        const landingWeight = plane.weight.empty + plane.weight.fuel + plane.weight.payload;
        const headTailWind = getHeadTailWind(runwayHeading, plane.wind);

        const LDR = getLDR(plane.type, plane.temperature, plane.altitude, landingWeight, headTailWind);
        if ( convertToMeters(LDR) > LDA ) { // LDA is in meters
            this.dispatch(setCondition({condition: CONDITION_TYPES.LDR_EXCEEDED}));
        } else {
            this.dispatch(setPower({ power: 0 }));
            this.dispatch(setTas({ tas: 0 }));
    
            const airportDetails = getAirportDetails(this.airport.code);
            this.dispatch(moveTo({ coordinates: this.airport, altitude: airportDetails.elevation }));
            this.dispatch(setAirborn({ airborn: false }));
            this.landed = true;
        }
    }

    isComplete() {
        return this.landed;
    }
}
